import React, { useState } from 'react'
import { Box, Typography, TextField, CircularProgress, Button, Link } from '@mui/material'

import { post } from '../utils/http'
import { isPrivate } from '../utils/config'
import logo from '../assets/pathomiq-logo.png'

interface FormValues {
  email: string
}

const ForgotPassword = () => {
  const [form, setForm] = useState<FormValues>({email: ''})
  const [isLoading, setIsloading] = useState<boolean>(false)
  const [formResMsg, setFormResMsg] = useState<string>('')
  const [error, setError] = useState<string>('')

  const requestPasswordResetEmail = async () => {
    if (!form.email.length) {
      setError('Email is required')
      return
    }
    setIsloading(true)
    try {
      await post('Users/reset-password', form)
      setFormResMsg('Password reset instructions sent to your email')
    } catch (err) {
      console.log(err)
      setFormResMsg('Unable to access this account, It may not exist or has been deactivated')
    } finally {
      setIsloading(false)
    }
  }

  const validateEmail = (value: string) => {
    if (!value) {
      setError('Email is required')
      return
    }
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
    if (!emailRegex.test(value)) setError('Invalid email address')
    else setError('')
  }

  const handleChange = (e: any) => {
    setFormResMsg('')
    setForm(prevForm => ({...prevForm, [e.target.name]: e.target.value}))
    validateEmail(e.target.value)
  }

  return (
    <Box className='d-flex justify-content-center align-items-center' sx={{height: '100vh'}}>
      {isPrivate &&
        <Typography className='position-absolute' sx={{top: '1rem', left: '1rem'}} variant='caption'>
          Internal
        </Typography>
      }
      <Box className='d-flex flex-column align-items-center gap-3 p-5 w-100' component="form" autoComplete="off" sx={{minWidth: 300, maxWidth: 450}}>
        <img src={logo} width={80} className='mb-4' alt="PATHOMIQ"/>
        {/* <Typography className='mb-3 text-center' variant="h4" component="h1">Reset Your Password</Typography> */}
        <Typography className='text-center'>Enter Your Registered Email</Typography>
        <TextField
          label="Email"
          name='email'
          variant="outlined"
          value={form.email}
          onChange={handleChange}
          error={!!error}
          helperText={error}
          sx={{width: '100%'}}
        />
        {formResMsg.length ? <Typography color='secondary'>{formResMsg}</Typography> : null}
        <Button className='p-2 w-100 fs-6' variant="contained" onClick={requestPasswordResetEmail} disabled={isLoading}>
          {isLoading ? <CircularProgress size={25}/> : 'Send Link'}
        </Button>
        <Box className='d-flex justify-content-center'>
          <Typography>Not registered? <Link href="../signup">Sign up</Link></Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default ForgotPassword
